module.exports = __webpack_public_path__ + "img/website-01.ed9bd149.png";